module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-content layout-relatorios"
  }, [_c('div', {
    staticClass: "app-content-body"
  }, [_c('btn-relatorios', {
    on: {
      "buscaRelatorio": _vm.buscaRelatorio
    }
  }), _vm._v(" "), _c('table-relatorios', {
    attrs: {
      "dados": _vm.serverData
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b2c4162","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/relatorios/Main.vue
// module id = 1569
// module chunks = 17